import CREATE_POI_SCORE from './CreatePOIScoreReview.graphql'
import CREATE_TRIPGURU_SCOPE from './CreateTripGuruScoreReview.graphql'
import CREATE_TRIPGUIDE_SCOPE from './CreateTripGuideScoreReview.graphql'
import GET_REVIEW_DETAILS from './GetRewievDetails.graphql'
import CREATE_ACTIVITIES_SCOPE from './CreateActivitiesScoreReview.graphql'
//updateParts
import LEFT_POI_DETAILED_REVIEW from './LeftPoiDetailedReview.graphql'
import LEFT_TRIP_GURU_DETAILED_REVIEW from './LeftTripGuruDetailedReview.graphql'

export default {
  CREATE_POI_SCORE,
  CREATE_TRIPGURU_SCOPE,
  GET_REVIEW_DETAILS,
  LEFT_POI_DETAILED_REVIEW,
  LEFT_TRIP_GURU_DETAILED_REVIEW,
  CREATE_TRIPGUIDE_SCOPE,
  CREATE_ACTIVITIES_SCOPE
}



// WEBPACK FOOTER //
// src/graphql/Review/index.js